import React from "react";

const OrderInfo = ({ order }) => {
    const orderStatus = order?.status || "N/A";
    const fulfilmentStatus = order?.fulfill_status || "N/A";
    const orderTotal = order?.total || "N/A";

    return (
        <div className="flex flex-col">
            <div className="w-full p-4 pb-3 border border-b-0 border-ec-border rounded-tl-lg rounded-tr-lg">
                <h3 className="font-inter easycommerce-dashboard-order-section-title">
                    Order info
                </h3>
            </div>

            <div className="w-full h-full flex flex-col gap-1 p-4 pt-10 border border-ec-border rounded-bl-lg rounded-br-lg">
                <div className="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                    <p className="font-inter font-normal text-sm leading-4 text-ec-placeholder">
                        Order ID
                    </p>
                    <p className="font-inter font-normal text-sm leading-4 text-ec-body">
                        {order?.id || "N/A"}
                    </p>
                </div>
                <div className="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                    <p className="font-inter font-normal text-sm leading-4 text-ec-placeholder">
                        Order Date
                    </p>
                    <p className="font-inter font-normal text-sm leading-4 text-ec-body">
                        {order.created_at ? order.created_at : "N/A"}
                    </p>
                </div>
                <div className="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                    <p className="font-inter font-normal text-sm leading-4 text-ec-placeholder">
                        Order Status
                    </p>
                    <p className="font-inter font-normal text-sm leading-4 text-[#00BF7F]">
                        {orderStatus}
                    </p>
                </div>
                <div className="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                    <p className="font-inter font-normal text-sm leading-4 text-ec-placeholder">
                        Fulfilment Status
                    </p>
                    <p className="font-inter font-normal text-sm leading-4 text-[#FFBB00]">
                        {fulfilmentStatus}
                    </p>
                </div>
                <div className="w-full h-[42px] flex justify-between items-center border-b border-dashed border-b-ec-border">
                    <p className="font-inter font-normal text-sm leading-4 text-ec-placeholder">
                        Total
                    </p>
                    <p className="font-inter font-normal text-sm leading-4 text-ec-body">
                        {orderTotal}
                    </p>
                </div>
                <div className="w-full h-[42px] flex justify-between items-center">
                    <p className="font-inter font-normal text-sm leading-4 text-ec-placeholder">
                        Payment Method
                    </p>
                    <p className="font-inter font-normal text-sm leading-4 text-ec-body">
                        {order.transactions.payment_gateway}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default OrderInfo;
